import abi from "../artifacts/contracts/CryptoTransfer.sol/CryptoTransfer.json"

export const contractABI = abi.abi
export const contractAddress = '0x0ADE267DB25d11c572A1A891e5Be422Ccb59Ae3B'